import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { SeoBlock } from '../../../../components/SeoBlock';
import { generateSeoTitle } from '../../../../utils/helpers';
import { DEFAULT_URL } from '../../const';

interface ExpertsSeoBlockProps {
  tenantTitle?: string | null;
  seoImage: string;
}

const ExpertsSeoBlock: FC<ExpertsSeoBlockProps> = ({ tenantTitle, seoImage }) => {
  const { t } = useTranslation();

  return (
    <SeoBlock
      data={{
        seo_title: generateSeoTitle(t('page.discover.experts'), tenantTitle),
        seo_description: t('page.discover.expertsDescription'),
        share_image: seoImage,
      }}
      canonicalUrl={`${DEFAULT_URL}/experts`}
    />
  );
};

export default ExpertsSeoBlock;
